import i18n from 'scoreboard/components/i18n'
import prettyHelper from './pretty-helper'
import prettyTemplate from './pretty-filter.hbs'

const CommonFilterMeta = {
	/**
	 * Returns the label of a Filter by it's key (e.g. color -> 'Scorecard Color')
	 */
	filterLabel: function(key) {
		let code = this[key] && this[key].nameCode || null
		return code ? i18n.get(code) : null
	},

	/**
	 * Returns html <li> containing the description and filter controls of a filter
	 */
	listify: function(filterData, key) {
		let meta = this[key]
		if (!meta) return null
		let value = this.stringify(filterData, key)
		if (!value) return null
		let result = prettyTemplate({ nameCode: meta.nameCode, filterKey: key,
			value: value})
		return result || null
	},
	/**
	 * Returns a descriptive text of the filter
	 */
	stringify: function(filterData, key) {
		let meta = this[key]
		//apply filter specific stringify else use generic filter type specific
		if (meta.stringify) {
			return meta.stringify(filterData)
		}
		return prettyHelper.prettify(meta, filterData, key)
	}

}

export default CommonFilterMeta
CommonFilterMeta.__filename__ = 'reports/common/filter/common-filter-meta.js'
